<template>
  <v-layout row fluid>
    <v-icon
      v-if="!hideDragIcon"
      class="reorder-icon d-block mr-1 pr-1"
      color="secondary"
      style="margin-top:13px; margin-left:-32px; cursor:pointer">
      swap_vert
    </v-icon>
    <v-expansion-panel
      class="mb-3 tasklist-expander p-relative parent-expansion elevation-2 rounded-3 withRemove on-white-bg">
      <div class="horiz-left-coloured-bg">
        <v-icon color="secondary" class="mt-0 ml-2 horiz-left-coloured-bg--icon">done_all</v-icon>
      </div>
      <v-expansion-panel-content>
        <div slot="header" class="tasklist-name-header">
          <h3 v-if="!editable"  class="text-truncate py-1 ml-2 pl-4 horiz-left-coloured-bg--padding-header">
            {{tasklistName}}
            <span v-if="tasklist.tasks" class="task-number">({{tasklist.tasks.length}})</span>
            <span v-if="!tasklist.tasks" class="task-number">(0)</span>
            <v-tooltip left color="secondary">
              <v-btn slot="activator" class="tasklist-name-edit-btn " @click.stop="rename()" icon><v-icon small>edit</v-icon></v-btn>
              <span>Edit task</span>
            </v-tooltip>
          </h3>
          <v-btn @click.stop="deleteDialog = true"  class="remove-icon" icon>
            <v-icon color="error">cancel</v-icon>
          </v-btn>
          <div v-if="editable" class="horiz-left-coloured-bg--padding tasklist-name-edit-field">
            <v-text-field
              class="pl-0 ml-4"
              v-model="tasklistName" label="Tasklist name"
              solo flat @click.stop>
            </v-text-field>
            <v-btn v-on:click.stop="saveChanges()" style="position:absolute;top:3px; right:-55px;" icon>
              <v-icon color="success">done</v-icon>
            </v-btn>
            <v-btn
              icon @click.stop v-on:click.stop="cancelRename()"
              style="position:absolute;top:3px; right:-90px;">
              <v-icon color="error">clear</v-icon>
            </v-btn>
          </div>
        </div>
      <v-layout class="horiz-left-coloured-bg--padding">
        <v-flex pr-4 pl-4 pb-4>
        <v-divider></v-divider>
        <draggable
          style="width: 100%; min-height: 10px;"
          v-model="tasks"
          :ghost="true"
        >
          <sortable-task
            v-for="(task, index) in tasks" :key="task.id"
            :taskTemplate="task"
            :tasklistId="tasklist.id"
            :position="index"
            :index="index"
            :caseType="caseType"
            :scripts="scripts"
            v-on:task-remove="removeTask">
          </sortable-task>
        </draggable>
        <v-btn @click="addTask()" color="secondary" class="ml-0 mt-3">Add a task</v-btn>
        </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <delete-dialog :isOpen="deleteDialog" itemType="tasklist" v-on:delete-item="removeTasklist"></delete-dialog>
  </v-layout>
</template>

<script>
import DeleteDialog from "@/components/shared/deleteDialog"
import draggable from "vuedraggable"
import SortableTask from "./SortableTask.vue"
import Helpers from "@/helpers.js"
import { mapState } from 'vuex'

export default {
  name: "TaskTemplateList",
  props: {
    caseType: { type: Object, required: true },
    tasklist: { type: Object, required: true },
    position: { type: Number, required: true }
  },
  components: { SortableTask, draggable, DeleteDialog },
  data: () => ({
    editable: false,
    deleteDialog: false
  }),
  computed: {
    ...mapState({
      hideDragIcon: state => state.ui.hideDragIcons
    }),
    scripts() {
      return this.caseType.scripts
    },
    functions() {
      if (this.scripts.length > 0) {
        const functions = []
        this.scripts.forEach(function(script) { functions.push({ id: script.id, name: script.name }) })
        return functions
      } else {
        return []
      }
    },
    tasklistName: {
      get() {
        if (this.tasklist && this.tasklist.name) { return this.tasklist.name } else { return "" }
      },
      set(name) {
        this.tasklist.name = name
      }

    },
    tasks: {
      get() {
        if (this.tasklist && this.tasklist.tasks) {
          Helpers.orderItemsByPosition(this.tasklist.tasks)
          return this.tasklist.tasks
        } else {
          return []
        }
      },
      set(tasks) {
        Helpers.updateItemPositions(tasks)
      }
    }
  },
  watch: {
    position() {
      this.tasklist.position = this.position
      this.$store.dispatch("updateTasklistTemplate", this.tasklist)
    }
  },
  methods: {
    async addTask() {
      const newTask = {
        tasklist_id: this.tasklist.id,
        key: "",
        description: "New " + this.tasklistName + " task",
        guidance: "",
        actionType: "",
        actionDefinition: "",
        position: this.tasklist.tasks.length
      }
      const response = await this.$store.dispatch('createTaskTemplate', newTask)
      if (!response.error) {
        newTask.id = response.id
        this.tasklist.tasks.push(newTask)
      }
    },
    async removeTask(taskId) {
      const response = await this.$store.dispatch('deleteTaskTemplate', taskId)
      if (!response.error) {
        const removeTask = this.tasklist.tasks.find((currentTask) => (currentTask.id === taskId))
        const index = this.tasklist.tasks.indexOf(removeTask)
        if (index >= 0) this.tasklist.tasks.splice(index, 1)
      }
    },
    removeTasklist(shouldDelete) {
      this.deleteDialog = false
      if (shouldDelete) {
        this.isOpen = null
        this.editable = false
        this.$emit('tasklist-remove')
      }
    },
    rename() {
      this.tasklistName = this.tasklist.name
      this.editable = true
    },
    async saveChanges() {
      const result = await this.$store.dispatch("updateTasklistTemplate", this.tasklist)
      if (!result.error) {
        this.tasklist.name = this.tasklistName
      }
      this.editable = false
    },
    cancelRename() {
      this.tasklistName = this.tasklist.name
      this.editable = false
    }
  }
}
</script>
